import axios from "axios";
import Qs from "qs";

const client = axios.create({
    paramsSerializer: params => Qs.stringify(params, {arrayFormat: 'repeat'})
});

export default client;